import React from 'react'
import SearchInput from '../../../inputs/SearchInput'

function SearchBox({ submitSearch, search_value, inputHandler }) {
  return (
    <div className="grid sm:grid-cols-1 gap-6 bg-light-blue py-4 sm:py-9 px-3 sm:px-8 w-full rounded-2xl border border-light-gray shadow-info-count block dark:bg-slate-800 dark:border-gray-700 dark:shadow-none">
      <form className="flex items-center justify-center" onSubmit={submitSearch}>
        <SearchInput
          isNumber={true}
          search_value={search_value}
          inputHandler={inputHandler}
          placeholder={'شماره تلفن همراه را وارد کنید'}
        />
      </form>
    </div>
  )
}

export default React.memo(SearchBox)
